module.exports = __webpack_public_path__ + "media/images/phone-icon-136fa85aea37e8578bcb21e261b9fa1508a4dbd35a3de9631f0221c63d9e13b5.png";